import { FEATURE_SETTINGS_CHANGED_EVENT, isFeatureEnabled } from "@/config/features";
import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void) => {
  window.addEventListener(FEATURE_SETTINGS_CHANGED_EVENT, onChange);
  window.addEventListener("storage", onChange);
  return () => {
    window.removeEventListener(FEATURE_SETTINGS_CHANGED_EVENT, onChange);
    window.removeEventListener("storage", onChange);
  };
};

export const useEventResolutionEnabled = () => useSyncExternalStore(
  subscribe,
  () => isFeatureEnabled("experimental.event_resolution"),
);
